import { useEffect } from "react";
import { Navigate, Outlet, useParams } from "react-router-dom";

import { usePartnerData } from "../../providers/partnerData";

import RemoteSupport from "../../components/Elements/RemoteSupport";
import ScrollToTop from "../../components/Elements/ScrollToTop";
import { LoadingScreen } from "../../components/Elements/LoadingScreen";

import GlobalStyle from "../../styles/global";

const RoutePartner = () => {
  const { partnerUrl } = useParams();
  const { loadPartner, hasPartner, isLoading, partnerData } = usePartnerData();

  useEffect(() => {
    if (partnerUrl) {
      loadPartner(partnerUrl);
    }
  }, []);

  return isLoading ? (
    <LoadingScreen />
  ) : !hasPartner ? (
    <Navigate to={"/"} />
  ) : (
    <>
      {partnerData?.remoteSupportConfig.map((config, index) => {
        return <RemoteSupport key={index} config={config} />;
      })}

      <GlobalStyle customStyle={partnerData?.cssStyle} />
      <ScrollToTop />
      <Outlet />
    </>
  );
};

export default RoutePartner;
